import React from 'react';
import useScript from '@sls-react/hooks/useScript';

interface Props {}

const TrustpilotFooter: React.FC<Props> = () => {
  useScript('//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js');

  return (
    <div
      className="my-8 text-center trustpilot-widget"
      data-locale="en-US"
      data-template-id="5419b637fa0340045cd0c936"
      data-businessunit-id="55d25dce0000ff000582430a"
      data-style-height="20px"
      data-style-width="100%"
      data-theme="dark"
    >
      <a
        href="https://www.trustpilot.com/review/sidelineswap.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        Trustpilot
      </a>
    </div>
  );
};

export default TrustpilotFooter;
